/*
 * Cupom de desconto direto no carrinho.
 *
 * A Ajax Cart API não tem endpoint de desconto — daí a crença comum de que só
 * dá para aplicar cupom no checkout. Mas a rota /discount/CODIGO grava o código
 * na sessão, e a partir daí o /cart.js devolve tudo: total já abatido,
 * total_discount e discount_codes[].applicable. Testado na loja:
 *
 *   R$ 151,80 -> /discount/OFFRELAMPAGO -> R$ 144,21
 *   discount_codes: [{code:'OFFRELAMPAGO', applicable:true}]
 *
 * O `applicable` é o que permite dar retorno de verdade: cupom inexistente e
 * cupom com condição não atendida voltam ambos como false, sem exceção.
 *
 * Para remover, /discount/ vazio dá 404 — quem limpa é /cart/update.js com
 * {discount:''}.
 *
 * O desconto fica na sessão e segue para o checkout; aqui só refletimos.
 */
(function () {
  'use strict';

  if (window.sdnCartCupom) return;
  window.sdnCartCupom = true;

  var moeda = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
  var fmt = function (centavos) { return moeda.format(centavos / 100); };

  function raiz() { return document.querySelector('[data-sdn-cupom]'); }

  function codigoAplicado(carrinho) {
    var codigos = carrinho.discount_codes || [];
    for (var i = 0; i < codigos.length; i++) {
      if (codigos[i].applicable) return codigos[i].code;
    }
    return null;
  }

  /* Quanto o CUPOM sozinho abateu.

     Não dá para usar total_discount: ele soma todo desconto do carrinho,
     inclusive o 5% automático do PIX, que existe com ou sem cupom. Numa cesta
     de R$ 113,20 isso mostrava −R$ 11,32 quando o cupom tinha tirado R$ 5,66 —
     e o checkout lista os dois separados, então a soma não batia com nada.

     Mas olhar só cart_level_discount_applications também não serve: ali entram
     apenas os descontos de pedido inteiro (target_selection 'all'). Cupom
     restrito a produto ou coleção — o caso dos cupons de influencer, tipo
     FERNANDA e BAJU — a Shopify aloca por linha, e aparece só em
     line_level_discount_allocations de cada item. O carrinho mostrava −R$ 0,00
     com o cupom válido e aplicado, porque procurava no lugar errado.

     As duas listas são disjuntas de propósito (line_level_ exclui o que é de
     carrinho), então somar as duas não conta nada duas vezes.

     A separação também não pode depender de title === código: em desconto
     criado por app o title é o NOME do desconto, não o code digitado.

     Medido no carrinho real (Pré-Treino Striker, cupom BAJU):
       carrinho  type ''              '5% de desconto no Pix'  370
       linha     type 'discount_code' 'BAJU'                   389
     O desconto do PIX é de carrinho, não de linha, e vem com type VAZIO — a
     blocklist de títulos '5nopix'/'5pix' que o carrinho antigo usa está morta,
     o título mudou. Então quem separa é o type; o título só entra como
     desempate para o caso de um cupom vir sem type. */
  function descontoDoCupom(carrinho) {
    var codigos = (carrinho.discount_codes || [])
      .filter(function (c) { return c.applicable; })
      .map(function (c) { return String(c.code).toUpperCase(); });

    if (!codigos.length) return 0;

    function ehCupom(app) {
      if (!app) return false;
      if (app.type === 'discount_code') return true;
      return codigos.indexOf(String(app.title || '').toUpperCase()) !== -1;
    }

    var total = 0;
    var i;

    var apps = carrinho.cart_level_discount_applications || [];
    for (i = 0; i < apps.length; i++) {
      if (ehCupom(apps[i])) total += parseInt(apps[i].total_allocated_amount || 0, 10);
    }

    var itens = carrinho.items || [];
    for (i = 0; i < itens.length; i++) {
      var alocs = itens[i].line_level_discount_allocations || [];
      for (var j = 0; j < alocs.length; j++) {
        if (ehCupom(alocs[j].discount_application)) total += parseInt(alocs[j].amount || 0, 10);
      }
    }

    return total;
  }

  function mensagem(texto, erro) {
    var el = document.querySelector('[data-sdn-cupom-msg]');
    if (!el) return;
    if (!texto) { el.hidden = true; el.textContent = ''; return; }
    el.textContent = texto;
    el.classList.toggle('sdn-cupom__msg--erro', !!erro);
    el.hidden = false;
  }

  /* O total do rodapé vem do Liquid somando original_line_price. Esse valor
     ignora desconto de propósito: o rodapé mostra o preço cheio e cita o PIX
     à parte, e mexer nisso mudaria a leitura de toda a loja.

     Então a conta aqui é só `base do Liquid − desconto do cupom`. Usar
     total_price seria errado: ele já vem com o 5% do PIX descontado, e a linha
     do PIX logo abaixo tiraria outros 5% em cima disso.

     A base sobrevive no data-cart-subtotal, que o cart-drawer.js reescreve a
     cada render — por isso remover o cupom restaura sozinho. */
  function pintarTotais(carrinho) {
    var elTotal = document.querySelector('.ec-cart-footer__total-value');
    var elPix = document.querySelector('.ec-payment-pix-value');
    var elParc = document.querySelector('.ec-payment-installment-value');
    if (!elTotal) return;

    var base = parseInt(elTotal.getAttribute('data-cart-subtotal') || '0', 10);
    if (!base) return;
    var total = Math.max(0, base - descontoDoCupom(carrinho));

    elTotal.textContent = fmt(total);
    if (elPix) elPix.textContent = fmt(Math.round(total * 0.95));
    if (elParc) elParc.textContent = fmt(Math.round(total / 3));
  }

  function pintarCupom(carrinho) {
    var caixa = document.querySelector('[data-sdn-cupom-ativo]');
    var form = document.querySelector('[data-sdn-cupom-form]');
    if (!caixa || !form) return;

    var ativo = codigoAplicado(carrinho);

    if (!ativo) {
      caixa.hidden = true;
      form.hidden = false;
      return;
    }

    var elCod = caixa.querySelector('[data-sdn-cupom-codigo]');
    var elVal = caixa.querySelector('[data-sdn-cupom-valor]');
    if (elCod) elCod.textContent = ativo;
    if (elVal) elVal.textContent = '− ' + fmt(descontoDoCupom(carrinho));
    caixa.hidden = false;
    form.hidden = true;
  }

  function lerCarrinho() {
    return fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart.js' : '/cart.js', {
      headers: { Accept: 'application/json' }
    }).then(function (r) { return r.json(); });
  }

  function limpar() {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: '' })
    });
  }

  function sincronizar() {
    if (!raiz()) return Promise.resolve();
    return lerCarrinho().then(function (carrinho) {
      pintarCupom(carrinho);
      pintarTotais(carrinho);
      return carrinho;
    });
  }

  function aplicar(codigo) {
    var botao = document.querySelector('[data-sdn-cupom-aplicar]');
    var rotulo = botao ? botao.textContent : 'Aplicar';
    if (botao) { botao.disabled = true; botao.textContent = '...'; }
    mensagem('');

    // A rota devolve um redirect com HTML; o corpo não interessa, só o efeito
    // colateral na sessão.
    return fetch('/discount/' + encodeURIComponent(codigo))
      .then(function (resposta) {
        /* fetch segue o 302 da rota, então !ok aqui é falha de verdade — e não
           cupom recusado, que só se descobre lendo o carrinho depois. O caso
           mais comum é 401 no `shopify theme dev`, que não faz proxy desta
           rota: cupom só dá para testar em produção ou tema de preview. */
        if (!resposta.ok) {
          var falha = new Error('rota /discount/ respondeu ' + resposta.status);
          falha.rota = true;
          throw falha;
        }
        return lerCarrinho();
      })
      .then(function (carrinho) {
        var codigos = carrinho.discount_codes || [];
        var aplicavel = codigos.some(function (c) { return c.applicable; });

        if (aplicavel) {
          pintarCupom(carrinho);
          pintarTotais(carrinho);
          mensagem('Cupom aplicado.', false);
          return;
        }

        /* Código recusado fica pendurado na sessão como applicable:false e
           atrapalharia a próxima tentativa. Limpa e relê, em vez de supor como
           a Shopify trata a substituição de um código por outro. */
        return limpar().then(sincronizar).then(function () {
          mensagem('Cupom inválido ou não aplicável a estes produtos.', true);
        });
      })
      .catch(function (erro) {
        console.error('[sdn-cart-cupom]', erro);
        if (erro && erro.rota) {
          mensagem('Não foi possível validar o cupom agora. Tente novamente.', true);
        } else {
          mensagem('Erro de conexão. Verifique sua internet e tente novamente.', true);
        }
      })
      .then(function () {
        if (botao) { botao.disabled = false; botao.textContent = rotulo; }
      });
  }

  document.addEventListener('submit', function (evento) {
    var form = evento.target.closest ? evento.target.closest('[data-sdn-cupom-form]') : null;
    if (!form) return;
    evento.preventDefault();
    var campo = form.querySelector('[data-sdn-cupom-input]');
    var codigo = campo ? campo.value.trim() : '';
    if (!codigo) { mensagem('Digite um código.', true); return; }
    aplicar(codigo);
  });

  document.addEventListener('click', function (evento) {
    if (!evento.target.closest || !evento.target.closest('[data-sdn-cupom-remover]')) return;
    limpar().then(sincronizar).then(function () {
      mensagem('Cupom removido.', false);
      var campo = document.querySelector('[data-sdn-cupom-input]');
      if (campo) campo.value = '';
    });
  });

  /* O cart-drawer.js redesenha o rodapé a cada mudança de quantidade, e os
     valores voltam do Liquid sem desconto. Repintar no evento dele mantém o
     total coerente sem precisar tocar no Liquid. */
  document.addEventListener('cart:dom-updated', sincronizar);
  document.addEventListener('DOMContentLoaded', sincronizar);
  if (document.readyState !== 'loading') sincronizar();
})();
